import React from 'react'
import { translations } from 'translations/translations'

export type TranslationFunc = (key: keyof typeof translations.en | string) => string;

export const TranslationContext = React.createContext(
  { t: () => '' } as { t: TranslationFunc; }
)
